import React from "react";
import {useParams} from "react-router-dom";
import useScript from "hooks/useScript";

import MainContainer from "layout/atoms/MainContainer";

function getApiBaseUrl() {
  // In development, use localhost backend
  if (process.env.NODE_ENV === 'development') {
    return 'http://localhost:8081/';
  }
  
  // In production, determine based on hostname
  const hostname = window.location.hostname;
  
  if (hostname.includes('stage') || hostname.includes('staging')) {
    return 'http://stage.ideolo.co/';
  }
  
  // Default to production
  return 'https://app.ideolo.co/';
}

function PublicView() {
  let params = useParams();
  const apiBaseUrl = getApiBaseUrl();
  
  useScript(`${apiBaseUrl}widget/index.js`);

  return (
    <MainContainer alignCenter>
      <div
        id="ideolo-board"
        data-base-url={apiBaseUrl}
        data-company-slug={params.companySlug}
        data-board-slug={params.boardSlug}
      ></div>
    </MainContainer>
  );
}

export default PublicView;
